import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type {UserType} from "../di-chat-adapter";
import type {Theme} from "di-chat-model";

export interface AppState {
  userType: UserType;
  theme: Theme;
  fontSize: string;
  isMaximized: boolean;
  isOpened: boolean;
  isMobile: boolean;
  isLoggedIn: boolean;
}


const initialState: AppState = {
  userType: "user",
  theme: "default",
  fontSize: "1rem",
  isMaximized: false,
  isOpened: false,
  isMobile: false,
  isLoggedIn: false,
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setUserType: (state, action: PayloadAction<UserType>) => {
      state.userType = action.payload;
    },
    setTheme: (state, action: PayloadAction<Theme>) => {
      state.theme = action.payload
    },
    setFontSize: (state, action: PayloadAction<string> ) => {
      state.fontSize = action.payload;
    },
    setIsMaximized: (state, action: PayloadAction<boolean>) => {
      state.isMaximized = action.payload
    },
    setIsOpened: (state, action: PayloadAction<boolean>) => {
      state.isOpened = action.payload
    },
    setIsMobile: (state, action: PayloadAction<boolean>) => {
      state.isMobile = action.payload
    },
    setIsLoggedIn: (state, action: PayloadAction<boolean>) => {
      state.isLoggedIn = action.payload;
    }
  }
});

// Action creators are generated for each case reducer function
export const { setUserType, setTheme, setFontSize, setIsMaximized, setIsOpened, setIsMobile, setIsLoggedIn } = appSlice.actions

export default appSlice.reducer